import Advisor from '@advisor/models/store/advisor/index';
// eslint-disable-next-line import/no-cycle
import RwAdvisorService from '@advisor/rwSdk/AdvisorService';
import RwCustodianService from '@advisor/rwSdk/CustodianService';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';

export const stateObj = function () {
  return new Advisor();
};

export const getters = {
  getFormattedAdvisors(state) {
    return state.allAdvisors.map((advisor) => ({
      name: `${advisor.firstName} ${advisor.lastName}`,
      id: advisor.riaUserId,
    }));
  },
};

export const actions = {
  async getAdvisors({commit}, payload) {
    try {
      const data = await RwAdvisorService.getAdvisors(payload).catch((error) => {
        throw error;
      });

      commit('SET_ADVISORS', data);
    } catch (error) {
      exceptionHandler.handleGenericException('advisor.getAdvisors', error);
    }
  },
  async moneyTransferRequest({commit}, payload) {
    try {
      const response = await RwCustodianService.getTransferMoneyRequests(payload).catch((error) => {
        throw error;
      });
      const {data} = response;

      commit('SET_MONEY_TRANSFERS', data);
    } catch (error) {
      exceptionHandler.handleGenericException('advisor.moneyTransferRequest', error);
    }
  },
  // eslint-disable-next-line consistent-return
  async getWorkflowDocuments({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({...payload}, rootState.settings.default);
      const sdkResponse = await RwAdvisorService.getWorkflowDocuments(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_WORKFLOWS', sdkResponse.data);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('advisor.getWorkflowDocuments', error);
    }
  },
};

export const mutations = {
  SET_ADVISORS(state, payload) {
    state.allAdvisors = payload;
  },
  SET_MONEY_TRANSFERS(state, payload) {
    state.moneyTransfers = payload;
  },
  SET_WORKFLOWS(state, payload) {
    state.workflows = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
